/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import TribalismFooter from "components/Footer/TribalismFooter.js";
// sections for this page

import SectionOfficePhotos from "pages-sections/about-us/SectionOfficePhotos.js";
import SectionContact from "pages-sections/about-us/SectionContact.js";

import styles from "pages-sections/services/ServicesSections.module.scss";

export default function AboutUsPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Photo Gallery - Tribalism"
        image="/img/bg9-sm.webp"
        url="https://www.tribalism.com.au/about/photo-gallery"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. Meet our amazing team and learn about how we work !"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/bg9-sm.webp" filter="dark" small>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
                classes.textCenter
              )}
            >
              <h1 className={classes.title}>Photo Gallery</h1>
              <h4>
                Meet the amazing team behind Tribalism and find out more about
                how we work.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <SectionOfficePhotos />
          <SectionContact />
        </div>
      </div>
      <TribalismFooter />
    </div>
  );
}
